import { connect } from 'react-redux';
import { About, IAboutProps } from '../../components/About';
import { getDescription, getNewbuildingName } from '../../selectors/newbuilding';
import { TApplicationState } from '../../types/redux';
import { trackOpenInfoAboutJK } from '../../actions/analytics';

type TAboutStateProps = Pick<IAboutProps, 'description' | 'displayName'>;

type TAboutDispatchProps = Pick<IAboutProps, 'trackActionOpenInfoAboutJK'>;

export function mapStateToProps(state: TApplicationState): TAboutStateProps {
  return {
    description: getDescription(state),
    displayName: getNewbuildingName(state),
  };
}

export function mapDispatchToProps(): TAboutDispatchProps {
  return {
    trackActionOpenInfoAboutJK: trackOpenInfoAboutJK,
  };
}

export const AboutContainer = connect(mapStateToProps, mapDispatchToProps)(About);
